// src/context/StoreContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const StoreContext = createContext();

export function StoreProvider({ children }) {
  const [categories, setCategories] = useState([]);
  const [items, setItems] = useState([]);

  const addCategory = useCallback((newCategory) => {
    setCategories(prev => [...prev, newCategory]);
  }, []);

  const updateCategory = useCallback((id, updatedCategory) => {
    setCategories(prev => 
      prev.map(cat => cat._id === id ? { ...cat, ...updatedCategory } : cat)
    );
  }, []);

  const deleteCategory = useCallback((id) => {
    setCategories(prev => prev.filter(cat => cat._id !== id));
  }, []);

  const addItem = useCallback((newItem) => {
    setItems(prev => [...prev, newItem]);
  }, []);

  const updateItem = useCallback((id, updatedItem) => {
    setItems(prev => 
      prev.map(item => item._id === id ? { ...item, ...updatedItem } : item)
    );
  }, []);

  const deleteItem = useCallback((id) => {
    setItems(prev => prev.filter(item => item._id !== id));
  }, []);

  const setInitialCategories = useCallback((categories) => {
    setCategories(categories);
  }, []);

  const setInitialItems = useCallback((items) => {
    setItems(items);
  }, []);

  return (
    <StoreContext.Provider value={{
      categories,
      items,
      addCategory,
      updateCategory,
      deleteCategory,
      addItem,
      updateItem,
      deleteItem,
      setInitialCategories,
      setInitialItems
    }}>
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);